import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import { NavLink } from "react-router-dom";

import { connection } from "../../utils/apiConnection.ts";

import img1 from "../../assets/images/company/p-village.png";
import img2 from "../../assets/images/company/آجیل-و-خشکبار-برادران-حسینی-logo_mobile-1537948183.png";
import pooyalogo from "../../assets/images/company/pooya-logo.png";
import kandoo from "../../assets/images/company/kandoo.png";
import logo1 from "../../assets/images/company/logo1.png";
import refah from "../../assets/images/company/refah.png";
import nonan from "../../assets/images/company/nonan.png";
import ofogh from "../../assets/images/company/ofogh-koorosh.png";

// Import Swiper styles
// import "swiper/scss";
// import "swiper/css/pagination";
// import "swiper/css/Navigation";

export default function Tradesman({
  type,
  companies,
  setCompanies,
  popularStore,
  setPopularStore,
}) {
  // useEffect(() => {
  //   connection("api/get_best_supplier").then(data => {
  //     setCompanies(data.data);

  //     console.log("companies : ", companies);
  //   });
  // }, []);

  return (
    <div className="tradesman ">
      {companies && (
        <div
          className="tradesman-main"
          //  style={{ marginTop: "100px" }}
        >
          {/* <div className="text-center mt-4">
            <span
              className="text-center fw-bold mb-2 py-2 title"
              style={{
                borderBottom: "3px solid #01394A",
                fontSize: "30px"
              }}
            >
              همکاران ما
            </span>
          </div> */}

          <div className="">
            <Swiper
              dir="rtl"
              spaceBetween={40}
              breakpoints={{
                1400: {
                  slidesPerView: 8,
                  spaceBetween: 25,
                },
                1200: {
                  slidesPerView: 8,
                },
                1100: {
                  slidesPerView: 6.5,
                  spaceBetween: 20,
                },
                1000: {
                  slidesPerView: 6,
                  spaceBetween: 25,
                },
                900: {
                  slidesPerView: 5.5,
                  spaceBetween: 15,
                },
                800: {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
                700: {
                  slidesPerView: 4.5,
                  spaceBetween: 15,
                },
                650: {
                  slidesPerView: 4,
                  spaceBetween: 25,
                },
                600: {
                  slidesPerView: 4,
                  spaceBetween: 15,
                },
                450: {
                  slidesPerView: 3,
                  spaceBetween: 15,
                },
                300: {
                  slidesPerView: 2.5,
                  spaceBetween: 15,
                },
              }}
              className="swiper pt-3 pb-4"
            >
              {companies.map((value) => {
                return (
                  <div>
                    {type == "hamkar" ? (
                      <>
                        {" "}
                        {value.info?.path && (
                          <SwiperSlide
                            className="swiper-slide rounded-circle d-flex justify-content-center text-center px-3 company"
                            style={{
                              width: "120px",
                              height: "120px",

                              // backgroundColor: "#F2F0F1"
                            }}
                          >
                            <NavLink
                              to={`/supplier/${value.info.suppliers__id}`}
                              target="blank"
                              // to={value.link}
                              style={{
                                textDecoration: "none",
                                color: "darkgreen",
                              }}
                            >
                              <div className="my-auto text-center d-flex align-items-center">
                                <img
                                  src={`http://sabadi.tatdemo.ir/${value.info.path}`}
                                  className="rounded-pill"
                                  style={{
                                    width: "110px",
                                    height: "110px",
                                    // borderRadius: "50px"
                                  }}
                                />
                              </div>
                            </NavLink>
                          </SwiperSlide>
                        )}
                      </>
                    ) : (
                      <>
                        {" "}
                        {value.path && (
                          <SwiperSlide
                            className="swiper-slide rounded-circle d-flex justify-content-center text-center px-3 company"
                            style={{
                              width: "120px",
                              height: "120px",

                              // backgroundColor: "#F2F0F1"
                            }}
                          >
                            <NavLink
                              to={`/supplier/${value.suppliers__id}`}
                              target="blank"
                              // to={value.link}
                              style={{
                                textDecoration: "none",
                                color: "darkgreen",
                              }}
                            >
                              <div className="my-auto text-center d-flex align-items-center">
                                <img
                                  src={`http://sabadi.tatdemo.ir/${value.path}`}
                                  className="rounded-pill"
                                  style={{
                                    width: "110px",
                                    height: "110px",
                                    // borderRadius: "50px"
                                  }}
                                />
                              </div>
                            </NavLink>
                          </SwiperSlide>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
}
